import React, { useEffect, useRef } from 'react';
import useResponsiblePersons from '@hooks/responsible-persons/responsible-persons';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { LovDTO } from '@api/ringil-api.v2';
import { deferStampDataTestIdOnDescendantRef, toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  responsiblePersonId: string;
  onChange: (responsiblePersonId: string) => void;
  style?: any;
  showClearButton?: boolean;
  disabled?: boolean;
  placeholder?: string;
  dataTestId?: string;
}

const InputResponsiblePersonPlain: React.FC<ComponentProps> = ({ responsiblePersonId, onChange, style, showClearButton = false, disabled = false, placeholder, dataTestId }) => {
  const responsiblePersons = useResponsiblePersons();
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    return deferStampDataTestIdOnDescendantRef(wrapperRef, '.p-dropdown', dataTestId);
  }, [dataTestId, responsiblePersons]);

  return (
    <div ref={wrapperRef}>
      <Dropdown
        value={responsiblePersonId}
        options={responsiblePersons}
        onChange={e => onChange(e.target.value)}
        optionLabel="name"
        optionValue={'id'}
        style={style}
        showClear={showClearButton}
        disabled={disabled}
        placeholder={placeholder}
        filter={true}
        itemTemplate={(option: LovDTO) => (
          <>
            {option.active ? (
              <span data-testid={dataTestId ? `${dataTestId}-${toTestIdSlug(option?.name || '')}` : undefined}>{option.name}</span>
            ) : (
              <span data-testid={dataTestId ? `${dataTestId}-${toTestIdSlug(option?.name || '')}` : undefined} style={{ textDecoration: 'line-through', color: 'gray' }}>
                {option.name}
              </span>
            )}
          </>
        )}
      />
    </div>
  );
};

export default InputResponsiblePersonPlain;
